import React from "react"
import CalendarPresets from "./CalendarPresets/CalendarPresets"
import CalendarHeader from "./CalendarHeader"
import CalendarFooter from "./CalendarFooter"
import { CalendarBodyProps } from "./MultiRangeCalendar.domain"

const CalendarBody = (props: CalendarBodyProps) => {
	const {
		definedRanges,
		ranges,
		showPresets,
		focusedCalendarRange,
		children,
		onFocusHeader,
		onChangePresets,
		onSubmit,
		onCancelSubmit,
		footerMenu,
		showCleanButtons = false,
		onClearPeriod,
	} = props

	return (
		<div className="multi-calendar-range">
			<div className="multi-calendar-range__content">
				<div className="multi-calendar-range__menu">
					<CalendarPresets
						ranges={ranges}
						onChange={onChangePresets}
						definedRanges={definedRanges}
						isVisible={showPresets}
					/>
					<div className="multi-calendar-range__menu-message">{footerMenu}</div>
				</div>
				<div className="multi-calendar-range__body">
					<CalendarHeader
						ranges={ranges}
						focusedCalendarRange={focusedCalendarRange}
						onFocus={onFocusHeader}
						showCleanButtons={showCleanButtons}
						clearPeriods={(index: number) => onClearPeriod(index, ranges)}
					/>
					<div className="multi-calendar-range__body--months">{children}</div>
				</div>
			</div>
			<div className="multi-calendar-range__footer">
				<CalendarFooter onSubmit={onSubmit} onCancelSubmit={onCancelSubmit} />
			</div>
		</div>
	)
}

export default CalendarBody
